// @owners { team: patients }

/**
 * True when the error is an expected transient network failure (lost connectivity,
 * interrupted response body read on Safari, app backgrounded, etc.). These should
 * not be reported to Sentry as uncaught exceptions.
 */
export function isExpectedNetworkError(error: unknown): boolean {
  if (error === null || typeof error !== 'object') {
    return false;
  }

  // NotReadableError is a DOMException name used by several Web APIs; only treat
  // actual DOMExceptions as the Safari fetch-body-read failure we intend to ignore.
  if (error instanceof DOMException && error.name === 'NotReadableError') {
    return true;
  }

  const { message } = error as { message?: string };

  if (typeof message !== 'string') {
    return false;
  }

  return message === 'Network request failed' || message.includes('I/O read operation failed');
}
